import React from "react";
import { FiGithub, FiLinkedin, FiFileText } from "react-icons/fi";
import styles from "./Navbar.module.css";

const Navbar = () => {
  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>Oscar Alberigo</div>
      <div className={styles.navLinks}>
        <div className={styles.socialLinks}>
          <a
            href="https://github.com/Oskito00"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FiGithub className={styles.icon} />
          </a>
          <a
            href="https://www.linkedin.com/in/oscar-alberigo-593744258/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FiLinkedin className={styles.icon} />
          </a>
          <a href="/CVApril27.pdf" target="_blank" rel="noopener noreferrer">
            <FiFileText className={styles.icon} />
          </a>
        </div>
        <a
          href="mailto:oscar.alberigo@gmail.com"
          className={styles.contactButton}
        >
          Contact
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
